/* This is the Climate Change Component N.2 */

<template>
  <v-container>
    <div>
      <strong>
        <span v-html="title"></span>
      </strong>
    </div>
    <div>
      <table
        style="height: 78px; width: 800px"
        border="1px;"
        cellspacing="0px;"
      >
        <tbody>
          <tr>
            <td
              style="
                width: 600px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              សំណួរ
            </td>
            <td
              style="
                width: 200px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              ចម្លើយជ្រើសរើស
            </td>
          </tr>
          <tr>
            <td class="row-data-left">{{ firstAidLabel[0] }}</td>
            <td class="row-data">
              <v-select
                class="py-0 px-1"
                v-model="data[0].d"
                :items="yesNo2"
                item-text="text"
                item-value="value"
                outline
                hide-details
                @keypress.native="onSelect($event, 0)"
              >
              </v-select>
            </td>
          </tr>
          <tr>
            <td class="row-data-left">{{ firstAidLabel[1] }}</td>
            <td class="row-data">
              <v-select
                class="py-0 px-1"
                v-model="data[1].d"
                :items="yesNo2"
                item-text="text"
                item-value="value"
                outline
                hide-details
                @keypress.native="onSelect($event, 1)"
              >
              </v-select>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import { firstAidLabel, yesNo2 } from "@/utils/ascf/climateVariables.js";
export default {
  props: ["data", "title"],
  data() {
    return {
      yesNo2: yesNo2,
      firstAidLabel: firstAidLabel,
    };
  },
  methods: {
    onSelect: function (event, r) {
      /* 2 options */
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 50) {
        this.data[r].d = charCode - 48;
        this.$forceUpdate();
      }
    },
  },
};
</script>
<style scoped>
.row-data {
  width: 100px;
  height: 35px;
  text-align: center;
  vertical-align: middle;
}
.row-data-left {
  width: 500px;
  height: 35px;
  text-align: left;
  vertical-align: middle;
}
.input-group--select >>> .input-group__selections__comma {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 12px;
  padding: 1px 1px 1px 0;
}
</style>